module.exports = __webpack_public_path__ + "assets/apple-icon-114x114.79975df5.png";